module.exports = __webpack_public_path__ + "static/media/06.fba2eee9.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/project/monuks/06.png
// module id = 140
// module chunks = 0